import type { ScheduleQuery } from "@myapp/contract";
import { useQuery } from "@tanstack/react-query";
import { SCHEDULE_POLL_MS } from "../../../../shared/config/polling";
import { scheduleKeys } from "../schedule.keys";
import { scheduleApi } from "../service";

/**
 * The one calendar query, for both the single-worker view and the all-technicians board.
 *
 * Pass `technicianIds: [id]` for one column, or omit it entirely for everyone. Replaces
 * `useWorkerCalendar` and `useTechnicianAppointments`, which hit two different endpoints and
 * returned two different shapes for what is the same question.
 */
export function useSchedule(
  query: Partial<ScheduleQuery>,
  options: { enabled?: boolean } = {},
) {
  const enabled = options.enabled ?? Boolean(query.from && query.to);

  return useQuery({
    queryKey: scheduleKeys.range(query),
    queryFn: async () => {
      const { data } = await scheduleApi.getSchedule(query);
      return data;
    },
    enabled,
    // Keep the previous window on screen while navigating, so columns do not flash empty.
    placeholderData: (prev) => prev,
    refetchInterval: SCHEDULE_POLL_MS,
    refetchIntervalInBackground: false,
  });
}
